/*
 * @Description: 部门设置
 * @Author: 杨志航
 * @Date: 2026-09-06 15:11:33
 */
import React, { useState, useEffect } from 'react'
import api from '@/api'
import {
  Form,
  Input,
  message,
} from 'antd'
import BtnGroup from '@/components/BtnGroup'
import { allTrim, filterParams } from '@/utils'

const FormItem = Form.Item

const EditDepart = (props) => {
  const { getFieldDecorator, validateFields, getFieldsValue, setFieldsValue } = props.form
  const { setVisible, editData, getList } = props
  const [saveLoading, setSaveLoading] = useState(false)

  useEffect(() => {
    const { name, leaderName } = editData
    setFieldsValue({
      name,
      leaderName,
    })
  }, [])

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  const formSubmit = (e) => {
    e.preventDefault()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        const { groupId, departmentType, groupName, groupLeaderName } = editData
        vals = filterParams(vals)
        vals = {
          groupId,
          departmentType,
          groupName,
          groupLeaderName,
          ...vals,
        }
        setSaveLoading(true)
        api.updateProfitReportDepartName(vals).then(() => {
          setSaveLoading(false)
          setVisible(false)
          message.success('设置成功')
          getList()
        }).catch(() => setSaveLoading(false))
      }
    })
  }

  return (
    <div>
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <FormItem label="OA部门名称">
          {editData.groupName || '--'}
        </FormItem>
        <FormItem label="小程序部门名称">
          {getFieldDecorator('name')(
            <Input placeholder="请输入小程序部门名称" />
          )}
        </FormItem>
        <FormItem label="OA部门负责人">
          {editData.groupLeaderName || '--'}
        </FormItem>
        <FormItem label="小程序部门负责人">
          {getFieldDecorator('leaderName')(
            <Input placeholder="请输入小程序中显示的负责人姓名" />
          )}
        </FormItem>
        <BtnGroup onCancel={() => setVisible(false)} loading={saveLoading} />
      </Form>
    </div>
  );
}

export default Form.create()(EditDepart)
